"use client";

import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { LuCheck } from "react-icons/lu";
import { IframeDialog } from "@/_components/ui/IframeDialog";

const FEATURE_KEYS = [
  "sso",
  "customContracts",
  "dedicatedSupport",
  "slaGuarantees",
] as const;

export default function EnterpriseCTA() {
  const t = useTranslations("pricing.enterprise");

  return (
    <Box
      position="relative"
      overflow="hidden"
      borderRadius="2xl"
      p={{ base: 8, md: 12 }}
      textAlign="center"
      mx="auto"
      maxW="4xl"
      bg="linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)"
      boxShadow="0 24px 48px -12px rgba(15, 52, 96, 0.45)"
    >
      <Box
        position="absolute"
        top="-40%"
        right="-20%"
        w="320px"
        h="320px"
        borderRadius="full"
        bg="primary.500"
        opacity={0.12}
        filter="blur(60px)"
        pointerEvents="none"
      />
      <VStack gap={5} position="relative">
        <Text
          textStyle="xs"
          fontWeight="bold"
          color="primary.300"
          letterSpacing="0.14em"
          textTransform="uppercase"
        >
          {t("eyebrow")}
        </Text>
        <Text
          as="h2"
          fontFamily="heading"
          textStyle={{ base: "2xl", md: "3xl" }}
          fontWeight="bold"
          color="white"
          letterSpacing="-0.02em"
          lineHeight={1.2}
        >
          {t("heading")}
        </Text>
        <Text color="neutral.300" textStyle="md" maxW="lg" lineHeight="tall">
          {t("subheading")}
        </Text>
        <HStack gap={3} mt={2} flexWrap="wrap" justify="center">
          <IframeDialog
            title={t("contactSales")}
            trigger={
              <Button
                size="lg"
                colorPalette="primary"
                borderRadius="xl"
                _hover={{ shadow: "shadow-primary-xl" }}
              >
                {t("contactSales")}
              </Button>
            }
            iframeHeight={{ base: "500px", md: "700px" }}
            variant="demo"
          />
        </HStack>
        <Flex gap={{ base: 4, md: 6 }} mt={4} flexWrap="wrap" justify="center">
          {FEATURE_KEYS.map((key) => (
            <HStack key={key} gap={1.5}>
              <Icon as={LuCheck} color="primary.300" boxSize={4} aria-hidden />
              <Text textStyle="xs" color="neutral.400" fontWeight="medium">
                {t(`features.${key}`)}
              </Text>
            </HStack>
          ))}
        </Flex>
      </VStack>
    </Box>
  );
}
